import { colors } from "@mui/material";

export const CalenderFilterEnum = {
  All: 0,
  This_Week: 1,
  Last_Week: 2,
  This_Month: 3,
  Last_Month: 4,
  This_Quarter: 5,
  Last_Quarter: 6,
  This_6_Months: 7,
  Last_6_Months: 8,
  This_Year: 9,
  Last_Year: 10,
  Custom_Date_Range: 11,
};
// utils/reactSelectStyles.js
export const globalSelectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({ ...base, zIndex: 9999 }),
  control: (base) => ({
    ...base,
    fontSize: "12px", // Global font size
    minHeight: "38px",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "12px",
    backgroundColor: state.isSelected ? "#E86B1B" : "white",
    color: state.isSelected ? "white" : "black",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#F4AD80", // lighter hover background
    },
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    color: "black",
  }),
};

export const SettingEnum = {
  UsersRole: 1,
  Designation: 2,
  StatusType: 3,
  Services: 4,
  ClientIndustry: 5,
  KRA: 6,
  ClientGrouping: 7,
  LeaveType: 8,
  EmailTemplate: 9,
  ProjectStage: 10,
};

export const FrequencyEnum = {
  Monthly: 1,
  Yearly: 2,
  Onetime: 3,
  Custom: 4,
};
